import React, { useState } from 'react';

interface IzakayaGalleryProps {
  lang: 'ja' | 'en';
}

const galleryImages = [
  {
    src: "https://public.readdy.ai/ai/img_res/34d5317cd3d8d18b0a7dbe4edb397856.jpg",
    captionJa: "地元ガイドと乾杯！",
    captionEn: "Cheers with your local guide!",
    span: "col-span-2 row-span-2"
  },
  {
    src: "https://readdy.ai/api/search-image?query=traditional%20japanese%20izakaya%20street%20alley%20at%20night%20glowing%20red%20lanterns%20narrow%20yokocho%20alley%20warm%20atmospheric%20lighting%20locals%20walking&width=600&height=400&seq=izakaya-gallery-2&orientation=landscape",
    captionJa: "昭和の雰囲気漂う横丁",
    captionEn: "Retro Showa-era alley",
    span: "col-span-1 row-span-1"
  },
  {
    src: "https://readdy.ai/api/search-image?query=close%20up%20of%20japanese%20izakaya%20food%20yakitori%20grilled%20skewers%20edamame%20sashimi%20on%20wooden%20table%20with%20beer%20mugs%20warm%20cozy%20atmosphere&width=600&height=400&seq=izakaya-gallery-3&orientation=landscape",
    captionJa: "本格的な居酒屋フード",
    captionEn: "Authentic izakaya food",
    span: "col-span-1 row-span-1"
  },
  {
    src: "https://readdy.ai/api/search-image?query=small%20intimate%20japanese%20bar%20counter%20with%20friendly%20bartender%20pouring%20sake%20local%20neighborhood%20bar%20no%20tourists%20warm%20lighting%20bottles%20shelves&width=600&height=400&seq=izakaya-gallery-4&orientation=landscape",
    captionJa: "地元常連だけの隠れ家バー",
    captionEn: "Hidden locals-only bar",
    span: "col-span-1 row-span-1"
  },
  {
    src: "https://readdy.ai/api/search-image?query=happy%20diverse%20group%20of%20travelers%20exploring%20tokyo%20nightlife%20together%20smiling%20walking%20through%20illuminated%20japanese%20shopping%20street%20at%20night&width=600&height=400&seq=izakaya-gallery-5&orientation=landscape",
    captionJa: "少人数でディープな夜散歩",
    captionEn: "Small group night walk",
    span: "col-span-1 row-span-1"
  },
  {
    src: "https://readdy.ai/api/search-image?query=japanese%20senbero%20cheap%20drinks%20set%20beer%20highball%20snacks%20on%20small%20izakaya%20table%20casual%20working%20class%20bar%20atmosphere%20warm%20glow&width=600&height=400&seq=izakaya-gallery-6&orientation=landscape",
    captionJa: "せんべろで気軽に一杯",
    captionEn: "Senbero — drinks from ¥1,000",
    span: "col-span-1 row-span-1"
  },
  {
    src: "https://readdy.ai/api/search-image?query=togoshi%20ginza%20shopping%20street%20at%20night%20tokyo%20local%20neighborhood%20illuminated%20storefronts%20izakaya%20signs%20people%20walking%20authentic%20local%20area&width=800&height=400&seq=izakaya-gallery-7&orientation=landscape",
    captionJa: "戸越銀座の夜",
    captionEn: "Togoshi Ginza at night",
    span: "col-span-2 row-span-1"
  }
];

const instagramPosts = [
  {
    src: "https://readdy.ai/api/search-image?query=square%20format%20instagram%20style%20photo%20of%20japanese%20izakaya%20interior%20warm%20amber%20light%20wooden%20counter%20stools%20sake%20bottles%20cozy%20night%20atmosphere&width=600&height=600&seq=ig-post-1&orientation=squarish",
    likes: 312,
    comments: 28,
    captionJa: "今夜も最高の一杯 🍺 #東京居酒屋 #戸越銀座",
    captionEn: "Another perfect night 🍺 #TokyoIzakaya #TogoshiGinza",
    tag: "@tokyolocalhost"
  },
  {
    src: "https://readdy.ai/api/search-image?query=square%20format%20instagram%20style%20photo%20of%20yakitori%20grilled%20chicken%20skewers%20on%20charcoal%20grill%20smoke%20rising%20japanese%20street%20food%20night%20market&width=600&height=600&seq=ig-post-2&orientation=squarish",
    likes: 487,
    comments: 41,
    captionJa: "炭火焼きの香りが最高 🔥 #焼き鳥 #居酒屋グルメ",
    captionEn: "The smell of charcoal grill 🔥 #Yakitori #IzakayaFood",
    tag: "@tokyolocalhost"
  },
  {
    src: "https://readdy.ai/api/search-image?query=square%20format%20instagram%20style%20photo%20of%20red%20paper%20lanterns%20glowing%20at%20night%20narrow%20japanese%20alley%20yokocho%20atmospheric%20moody%20photography&width=600&height=600&seq=ig-post-3&orientation=squarish",
    likes: 623,
    comments: 55,
    captionJa: "赤提灯の灯りに誘われて 🏮 #横丁 #昭和レトロ",
    captionEn: "Drawn in by the red lanterns 🏮 #Yokocho #ShowaRetro",
    tag: "@tokyolocalhost"
  },
  {
    src: "https://readdy.ai/api/search-image?query=square%20format%20instagram%20style%20photo%20of%20happy%20tourists%20group%20selfie%20inside%20japanese%20izakaya%20bar%20smiling%20holding%20beer%20glasses%20fun%20night%20out&width=600&height=600&seq=ig-post-4&orientation=squarish",
    likes: 891,
    comments: 73,
    captionJa: "みんなで乾杯！最高の夜 🥂 #東京ナイトツアー",
    captionEn: "Cheers everyone! Best night ever 🥂 #TokyoNightTour",
    tag: "@tokyolocalhost"
  },
  {
    src: "https://readdy.ai/api/search-image?query=square%20format%20instagram%20style%20photo%20of%20japanese%20highball%20whisky%20soda%20drink%20in%20tall%20glass%20with%20ice%20condensation%20bar%20counter%20night&width=600&height=600&seq=ig-post-5&orientation=squarish",
    likes: 256,
    comments: 19,
    captionJa: "ハイボールで乾杯 🥃 #ハイボール #せんべろ",
    captionEn: "Highball o'clock 🥃 #Highball #Senbero",
    tag: "@tokyolocalhost"
  },
  {
    src: "https://readdy.ai/api/search-image?query=square%20format%20instagram%20style%20photo%20of%20tokyo%20local%20neighborhood%20street%20at%20night%20neon%20signs%20izakaya%20storefronts%20people%20walking%20authentic%20japan&width=600&height=600&seq=ig-post-6&orientation=squarish",
    likes: 744,
    comments: 62,
    captionJa: "地元の夜を歩く 🌃 #東京ローカル #夜散歩",
    captionEn: "Walking the local night streets 🌃 #TokyoLocal #NightWalk",
    tag: "@tokyolocalhost"
  }
];

const highlights = [
  { labelJa: '居酒屋', labelEn: 'Izakaya', emoji: '🍺', seq: 'hl-1' },
  { labelJa: '横丁', labelEn: 'Yokocho', emoji: '🏮', seq: 'hl-2' },
  { labelJa: 'グルメ', labelEn: 'Food', emoji: '🍢', seq: 'hl-3' },
  { labelJa: '夜散歩', labelEn: 'Night Walk', emoji: '🌃', seq: 'hl-4' },
  { labelJa: 'ゲスト', labelEn: 'Guests', emoji: '🥂', seq: 'hl-5' },
];

export const IzakayaGallery: React.FC<IzakayaGalleryProps> = ({ lang }) => {
  const [lightbox, setLightbox] = useState<number | null>(null);
  const [hoveredPost, setHoveredPost] = useState<number | null>(null);
  const [activeHighlight, setActiveHighlight] = useState<number | null>(null);

  const heading = lang === 'ja'
    ? { title: 'ツアーの雰囲気', subtitle: '実際の体験をご覧ください' }
    : { title: 'Tour Highlights', subtitle: 'See what the experience looks like' };

  const igHeading = lang === 'ja'
    ? { title: 'Instagramで見る', subtitle: 'リアルな体験をSNSでチェック', cta: 'Instagramをフォロー', handle: '@tokyolocalhost' }
    : { title: 'As Seen on Instagram', subtitle: 'Real moments from real guests', cta: 'Follow on Instagram', handle: '@tokyolocalhost' };

  const closeLightbox = () => setLightbox(null);
  const prev = () => setLightbox(i => i !== null ? (i - 1 + galleryImages.length) % galleryImages.length : null);
  const next = () => setLightbox(i => i !== null ? (i + 1) % galleryImages.length : null);

  return (
    <>
      <section className="py-20 bg-stone-950">
        <div className="max-w-6xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-amber-500/20 rounded-full border border-amber-500/30 mb-4">
              <i className="ri-camera-line text-amber-400 text-sm"></i>
              <span className="text-amber-300 text-xs font-medium tracking-widest uppercase">Gallery</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">{heading.title}</h2>
            <p className="text-stone-400 text-lg">{heading.subtitle}</p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-4 grid-rows-3 gap-3 h-[600px]">
            {galleryImages.map((img, idx) => (
              <div
                key={idx}
                className={`${img.span} relative overflow-hidden rounded-xl cursor-pointer group`}
                onClick={() => setLightbox(idx)}
              >
                <img
                  src={img.src}
                  alt={lang === 'ja' ? img.captionJa : img.captionEn}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                  <p className="text-white text-sm font-medium">
                    {lang === 'ja' ? img.captionJa : img.captionEn}
                  </p>
                </div>
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-black/40 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-white text-sm"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Instagram Feed Section ── */}
      <section className="py-20 bg-stone-900">
        <div className="max-w-6xl mx-auto px-6">

          {/* ── Instagram Profile Bar ── */}
          <div className="mb-10 rounded-2xl border border-white/10 overflow-hidden"
            style={{ background: 'linear-gradient(135deg, rgba(249,115,22,0.08), rgba(236,72,153,0.08), rgba(168,85,247,0.08))' }}>

            {/* Top: profile info */}
            <div className="flex flex-col md:flex-row md:items-center gap-6 px-8 pt-8 pb-6">
              {/* Avatar with gradient ring */}
              <a
                href="https://www.instagram.com/tokyolocalhost/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 cursor-pointer"
              >
                <div className="w-20 h-20 rounded-full p-0.5 flex items-center justify-center"
                  style={{ background: 'linear-gradient(135deg, #f97316, #ec4899, #a855f7)' }}>
                  <div className="w-full h-full rounded-full overflow-hidden border-2 border-stone-900">
                    <img
                      src="https://readdy.ai/api/search-image?query=friendly%20japanese%20local%20guide%20smiling%20portrait%20close%20up%20warm%20izakaya%20bar%20background%20authentic%20tokyo%20night&width=200&height=200&seq=ig-avatar-host&orientation=squarish"
                      alt="tokyolocalhost"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </a>

              {/* Name + stats */}
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-3 mb-1">
                  <a
                    href="https://www.instagram.com/tokyolocalhost/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white font-bold text-lg hover:text-pink-300 transition-colors cursor-pointer"
                  >
                    tokyolocalhost
                  </a>
                  <div className="flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium text-white/70 border border-white/20">
                    <i className="ri-verified-badge-fill text-pink-400 text-xs"></i>
                    <span>{lang === 'ja' ? '公式アカウント' : 'Official'}</span>
                  </div>
                </div>

                {/* Stats row */}
                <div className="flex items-center gap-6 mb-3">
                  <div className="text-center">
                    <p className="text-white font-bold text-base leading-tight">248</p>
                    <p className="text-stone-400 text-xs">{lang === 'ja' ? '投稿' : 'posts'}</p>
                  </div>
                  <div className="w-px h-8 bg-white/10"></div>
                  <div className="text-center">
                    <p className="text-white font-bold text-base leading-tight">3,812</p>
                    <p className="text-stone-400 text-xs">{lang === 'ja' ? 'フォロワー' : 'followers'}</p>
                  </div>
                  <div className="w-px h-8 bg-white/10"></div>
                  <div className="text-center">
                    <p className="text-white font-bold text-base leading-tight">187</p>
                    <p className="text-stone-400 text-xs">{lang === 'ja' ? 'フォロー中' : 'following'}</p>
                  </div>
                </div>

                {/* Bio */}
                <p className="text-stone-300 text-sm leading-relaxed">
                  {lang === 'ja'
                    ? '🏮 地元民だけが知る東京の居酒屋へご案内 | 荏原町・中延・戸越・武蔵小山 | 少人数ツアー毎晩開催'
                    : '🏮 Tokyo izakaya tours only locals know | Ebara · Nakanobu · Togoshi · Musashi-Koyama | Nightly small-group tours'}
                </p>
              </div>

              {/* Follow button */}
              <div className="flex-shrink-0">
                <a
                  href="https://www.instagram.com/tokyolocalhost/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-white text-sm transition-all duration-300 hover:scale-105 hover:shadow-lg cursor-pointer whitespace-nowrap"
                  style={{ background: 'linear-gradient(135deg, #f97316, #ec4899, #a855f7)' }}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-instagram-line text-sm"></i>
                  </div>
                  {lang === 'ja' ? 'フォロー' : 'Follow'}
                </a>
              </div>
            </div>

            {/* Divider */}
            <div className="h-px bg-white/10 mx-8"></div>

            {/* Story Highlights */}
            <div className="px-8 py-5">
              <p className="text-stone-500 text-xs font-medium tracking-widest uppercase mb-4">
                {lang === 'ja' ? 'ストーリーズハイライト' : 'Story Highlights'}
              </p>
              <div className="flex items-center gap-5 overflow-x-auto pb-1 scrollbar-hide">
                {highlights.map((hl, idx) => (
                  <button
                    key={idx}
                    className="flex flex-col items-center gap-2 flex-shrink-0 cursor-pointer group"
                    onClick={() => setActiveHighlight(activeHighlight === idx ? null : idx)}
                  >
                    {/* Ring */}
                    <div
                      className={`w-16 h-16 rounded-full p-0.5 transition-all duration-300 ${activeHighlight === idx ? 'scale-110' : 'group-hover:scale-105'}`}
                      style={{
                        background: activeHighlight === idx
                          ? 'linear-gradient(135deg, #f97316, #ec4899, #a855f7)'
                          : 'linear-gradient(135deg, rgba(249,115,22,0.5), rgba(236,72,153,0.5), rgba(168,85,247,0.5))'
                      }}
                    >
                      <div className="w-full h-full rounded-full overflow-hidden border-2 border-stone-900 bg-stone-800 flex items-center justify-center">
                        <img
                          src={`https://readdy.ai/api/search-image?query=square%20instagram%20story%20highlight%20cover%20japanese%20izakaya%20night%20$%7Bhl.labelEn%7D%20warm%20amber%20glow%20minimal%20icon%20style&width=120&height=120&seq=${hl.seq}&orientation=squarish`}
                          alt={lang === 'ja' ? hl.labelJa : hl.labelEn}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    </div>
                    <span className={`text-xs font-medium transition-colors duration-200 ${activeHighlight === idx ? 'text-pink-300' : 'text-stone-400 group-hover:text-stone-200'}`}>
                      {lang === 'ja' ? hl.labelJa : hl.labelEn}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Instagram section title */}
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">{igHeading.title}</h2>
            <p className="text-stone-400">{igHeading.subtitle}</p>
          </div>

          {/* Instagram Grid */}
          <div className="grid grid-cols-3 gap-3">
            {instagramPosts.map((post, idx) => (
              <div
                key={idx}
                className="relative aspect-square overflow-hidden rounded-xl cursor-pointer group"
                onMouseEnter={() => setHoveredPost(idx)}
                onMouseLeave={() => setHoveredPost(null)}
              >
                <img
                  src={post.src}
                  alt={lang === 'ja' ? post.captionJa : post.captionEn}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />

                {/* Instagram gradient overlay on hover */}
                <div
                  className={`absolute inset-0 transition-opacity duration-300 ${hoveredPost === idx ? 'opacity-100' : 'opacity-0'}`}
                  style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.1) 100%)' }}
                ></div>

                {/* Top bar: Instagram icon + handle */}
                <div className={`absolute top-0 left-0 right-0 p-3 flex items-center gap-2 transition-all duration-300 ${hoveredPost === idx ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'}`}>
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-400 via-pink-500 to-purple-600">
                    <i className="ri-instagram-line text-white text-xs"></i>
                  </div>
                  <span className="text-white text-xs font-semibold">{post.tag}</span>
                </div>

                {/* Bottom: caption + likes/comments */}
                <div className={`absolute bottom-0 left-0 right-0 p-3 transition-all duration-300 ${hoveredPost === idx ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}>
                  <p className="text-white text-xs leading-relaxed mb-2 line-clamp-2">
                    {lang === 'ja' ? post.captionJa : post.captionEn}
                  </p>
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1.5">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-heart-fill text-red-400 text-sm"></i>
                      </div>
                      <span className="text-white/80 text-xs font-medium">{post.likes.toLocaleString()}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-chat-1-line text-white/70 text-sm"></i>
                      </div>
                      <span className="text-white/80 text-xs font-medium">{post.comments}</span>
                    </div>
                  </div>
                </div>

                {/* Default state: subtle Instagram badge */}
                <div className={`absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full bg-black/40 transition-opacity duration-300 ${hoveredPost === idx ? 'opacity-0' : 'opacity-70'}`}>
                  <i className="ri-instagram-line text-white text-xs"></i>
                </div>
              </div>
            ))}
          </div>

          {/* Follow CTA */}
          <div className="text-center mt-10">
            <a
              href="https://www.instagram.com/tokyolocalhost/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 px-8 py-3.5 rounded-full font-semibold text-white text-sm transition-all duration-300 hover:scale-105 hover:shadow-lg cursor-pointer whitespace-nowrap"
              style={{ background: 'linear-gradient(135deg, #f97316, #ec4899, #a855f7)' }}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-instagram-line text-base"></i>
              </div>
              {igHeading.cta}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
            <p className="text-stone-500 text-xs mt-3">
              {lang === 'ja' ? 'フォローして最新情報をチェック' : 'Follow for the latest updates'}
            </p>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition cursor-pointer"
            onClick={closeLightbox}
          >
            <i className="ri-close-line text-xl"></i>
          </button>
          <button
            className="absolute left-5 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition cursor-pointer"
            onClick={e => { e.stopPropagation(); prev(); }}
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            className="absolute right-5 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition cursor-pointer"
            onClick={e => { e.stopPropagation(); next(); }}
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div
            className="max-w-4xl w-full"
            onClick={e => e.stopPropagation()}
          >
            <img
              src={galleryImages[lightbox].src}
              alt={lang === 'ja' ? galleryImages[lightbox].captionJa : galleryImages[lightbox].captionEn}
              className="w-full max-h-[80vh] object-contain rounded-xl"
            />
            <p className="text-center text-white/80 mt-4 text-sm">
              {lang === 'ja' ? galleryImages[lightbox].captionJa : galleryImages[lightbox].captionEn}
            </p>
            <p className="text-center text-white/40 text-xs mt-1">
              {lightbox + 1} / {galleryImages.length}
            </p>
          </div>
        </div>
      )}
    </>
  );
};
